/** Tipos de cobrança adicional em pedidos B2B (Contas a Receber). */
export enum B2bAdditionalChargeType {
  CavaleteLateral = 'Cavalete Lateral',
  ProtetorDeMotos = 'Protetor de Motos',
  AdesivoPersonalizado = 'Adesivo personalizado',
  Bau90Litros = 'Baú 90 litros',
  Bau96Litros = 'Baú 96 Litros',
  AntenaCortaPipa = 'Antena corta Pipa',
  SuporteDeBau = 'Suporte de Baú'
}

export interface B2bAdditionalChargeTypeOption {
  value: B2bAdditionalChargeType;
  label: string;
}

export const B2B_ADDITIONAL_CHARGE_TYPE_OPTIONS: B2bAdditionalChargeTypeOption[] = [
  { value: B2bAdditionalChargeType.CavaleteLateral, label: B2bAdditionalChargeType.CavaleteLateral },
  { value: B2bAdditionalChargeType.ProtetorDeMotos, label: B2bAdditionalChargeType.ProtetorDeMotos },
  { value: B2bAdditionalChargeType.AdesivoPersonalizado, label: B2bAdditionalChargeType.AdesivoPersonalizado },
  { value: B2bAdditionalChargeType.Bau90Litros, label: B2bAdditionalChargeType.Bau90Litros },
  { value: B2bAdditionalChargeType.Bau96Litros, label: B2bAdditionalChargeType.Bau96Litros },
  { value: B2bAdditionalChargeType.AntenaCortaPipa, label: B2bAdditionalChargeType.AntenaCortaPipa },
  { value: B2bAdditionalChargeType.SuporteDeBau, label: B2bAdditionalChargeType.SuporteDeBau }
];
